var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"required-mark-component"},[(_vm.isDisplay)?_c('span',[_vm._v("❇︎")]):_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }